var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LineUp",class:_vm.getClass,on:{"click":_vm.saveLU}},[_c('span',[_vm._v(" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }